/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ProductSynonymsOperation} from './ProductSynonymsOperation';

export interface ProductSynonymsOperationLog {
  id?: number;
  operation: ProductSynonymsOperation;
  status: number;
  productProcessed: number;
  enabled?: boolean;
  deleted?: boolean;
  createdAt?: Date;
  finishedAt?: Date;
}
